import FormErrors from '../utilities/FormErrors';



window.CaptchaCallback = function() {
  document.querySelectorAll('.js-newsletter-submit-button').forEach((el, i) => {
    //6LfBcBcoAAAAAHkA94Ow4RlVSjd_ibcdOiCkXAUI
        grecaptcha.render(el, {'sitekey' : '6LcCcn8eAAAAADB7WA4P4yEOfKmaGTkR-w6Yj9bx', 'callback' : function(response) {
          console.log('render captcha');
          window.submitNewsLetter(i);
        }
        });
      });
}


window.CaptchaTimestamp = function() {
  document.querySelectorAll('.js-subscribe-form').forEach((form) => {
    var response = form.querySelector(".g-recaptcha-response"); 
    if (response == null || response.value.trim() == "") {
      var elems = JSON.parse(form.captcha_settings.value);
      elems["ts"] = JSON.stringify(new Date().getTime());
      form.captcha_settings.value = JSON.stringify(elems); 
    }
  });

}
setInterval(CaptchaTimestamp, 500);

window.submitNewsLetter = function(i) {

  //console.log(index);
    //e.preventDefault();
    let form = document.querySelectorAll('.js-subscribe-form')[i];
    let email = form.querySelector('[name="email"]').value;

    if(!/\S+@\S+\.\S+/.test(email)) { // invalid email

      let msg = '';
      if(email == "") {
        msg = 'Email can not be empty';
      } else {
        msg = 'Invalid Email';
      }

      let Errors = new FormErrors(form, {
        'email': msg
      });

      Errors.addErrorsToFormInputs();
      return false;
    }

    // check additional fields
    let firstName = form.first_name.value;
    let lastName = form.last_name.value;
    form.company.value = firstName + ' ' + lastName;
    form.Venue_Name__c.value = firstName + ' ' + lastName;

    let Errors = false;

    if(firstName == '') {
      Errors = new FormErrors(form, {
        'first_name': 'First Name can not be empty'
      });
    }

    if(lastName == '') {
      Errors = new FormErrors(form, {
        'last_name': 'Last Name can not be empty'
      });
    }

    if(Errors) {
      Errors.addErrorsToFormInputs();
      return false;
    }

    sessionStorage.setItem("email", email);
    sessionStorage.setItem("firstName", firstName);
    sessionStorage.setItem("lastName", lastName);

    // Push event to datalayer - GA tracking
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'mailinglistsubscribe'
    });

    // Call conversion reporting functions
    gtag_report_conversion(email, firstName, lastName);
    fb_report_conversion(email, firstName, lastName);


    // submit form
    form.submit();
    grecaptcha.reset();
}


let email = sessionStorage.getItem("email");
if(email) {
  let emailInput = document.querySelector('.js-checkout-account-create [name="email"]');

  if(typeof emailInput !="undefined" && emailInput !=null) {
    emailInput.value = email;
  }

  sessionStorage.removeItem('email');
}


if(sessionStorage.getItem("firstName") && sessionStorage.getItem("lastName")) {
  let firstNameInput = document.querySelector('.js-checkout-account-create [name="firstName"]');

  let lastNameInput = document.querySelector('.js-checkout-account-create [name="lastName"]');

  if(typeof firstNameInput !== "undefined" && firstNameInput !== null) {
    firstNameInput.value = sessionStorage.getItem("firstName");
  }
  
  if(typeof lastNameInput !== "undefined" && lastNameInput !== null) {
    lastNameInput.value = sessionStorage.getItem("lastName");
  }

  sessionStorage.removeItem('firstName');
  sessionStorage.removeItem('lastName');
}


if(location.href.includes("errorcode=8")) {
  location = location.href.split('?')[0];

  let form = document.getElementById(location.hash.substring(1));

  let Errors = new FormErrors(form, {
    'Email Address': 'This email address is already subscribed'
  });

  Errors.addErrorsToFormInputs();
}

  function gtag_report_conversion(email, first_name, last_name) {

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'user_data': {
        "email": email,
        "first_name": first_name,
        "last_name": last_name,
      }
    });
  
    gtag('event', 'newsletter_conversion', {
      'send_to': 'AW-'+window.AdConversionIds.conversion_id+'/'+window.AdConversionIds.newsletter.label,
    });
  }
  
  function fb_report_conversion(email, first_name, last_name) {
    // Prepare user data
    const userData = { email, first_name, last_name };
  
    // API call to report the conversion
    const apiUrl = '/api/send-news-letter-fb';
    const fetchOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(userData)
    };
    fetch(apiUrl, fetchOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
      })
      .catch(error => {
        console.log(error);
      });
  }
